export default __webpack_public_path__ + "static/media/laconic_cube.65e863b2.jpg";